import React, { Component } from 'react';
import autoBind from 'react-autobind';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import { asyncRequest, Entities, TOMCAT_URL } from 'src/common/index';
import { ButtonColors } from 'src/utils/constants';
import composeModalActions from 'src/utils/modal-action-wrapper';
import TableHelper from 'src/utils/table-helper';
import ConfirmDialog from 'src/components/misc/confirm-dialog';
import ErrorMessage from 'src/components/misc/error-message';
import SeasonCalculationEditModal from 'src/components/administration/season-calculation-edit-modal';
import { withTranslation } from 'react-i18next';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import { IconLabel } from 'src/components/administration/IconLabel';

class SeasonCalculationAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
            tripCompanies: {
                isFetching: true,
                entities: [],
                error: undefined,
            },
        };

        this.tableHelper = new TableHelper({ onRowClick: this.onRowClick });
    }

    componentWillMount() {
        const { selectedCompany } = this.props;

        this.props.fetchByCompanyId(Entities.SEASON_CALCULATION, selectedCompany);
        this.fetchTripCompanies();
    }

    fetchTripCompanies() {
        asyncRequest({
            method: 'GET',
            endpoint: `${TOMCAT_URL}api/${Entities.TRIP_COMPANY.repository}/get-all`,
        })
            .then(response => {
                this.setState({
                    tripCompanies: {
                        entities: response.json,
                        isFetching: false,
                        error: undefined,
                    },
                });
            })
            .catch(error =>
                this.setState({
                    companiesWithBuses: {
                        entities: [],
                        isFetching: false,
                        error: error.status,
                    },
                    filteredCompaniesWithBuses: [],
                }),
            );
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.modal.open;
    }

    componentWillReceiveProps(nextProps) {
        const { seasonCalculations } = nextProps;

        if (seasonCalculations.isFetching && !this.state.startedFetching) this.setState({ startedFetching: true });

        this.tableHelper.processPagination(seasonCalculations.items.length);
    }

    componentDidUpdate(prevProps) {
        if (
            this.tableHelper.processPaginationAfterUpdate(
                prevProps.seasonCalculations,
                this.props.seasonCalculations,
                this.table,
            )
        )
            this.setState({ renderSelection: !this.state.renderSelection });
    }

    render() {
        const { seasonCalculations, t } = this.props;
        const finishFetching =
            this.state.startedFetching && !seasonCalculations.isFetching && !this.state.tripCompanies.isFetching;

        const tableData = [];

        if (finishFetching && seasonCalculations.items.length > 0) {
            seasonCalculations.items.map(seasonCalculation => {
                tableData.push({
                    id: seasonCalculation.id,
                    name: seasonCalculation.name,
                });
            });
        }

        return (
            <div>
                <legend className="legend">
                    {t('administration.season_calculation')}
                    <button
                        className="btn btn-xs btn-blue btn-flex pull-right"
                        onClick={() => {
                            if (this.table) this.table.reset();
                            this.props.openModal({
                                component: SeasonCalculationEditModal,
                                componentProps: {
                                    isCreate: true,
                                    tripCompanies: this.state.tripCompanies.entities,
                                },
                                title: t('calculation.new_special_rate'),
                                mandatoryFields: true,
                            });
                        }}>
                        <IconLabel icon="plus" text={t('calculation.new_special_rate')} />
                    </button>
                </legend>

                {(() => {
                    if (seasonCalculations.error) return <ErrorMessage object={seasonCalculations} />;
                    else
                        return (
                            <BootstrapTableErrorBoundary>
                                <BootstrapTable
                                    ref={ref => (this.table = ref)}
                                    data={tableData}
                                    exportCSV={true}
                                    striped={true}
                                    hover={true}
                                    condensed={true}
                                    pagination={true}
                                    options={Object.assign({}, this.tableHelper.getOptions(finishFetching))}
                                    selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                                    searchPlaceholder={t('common_phrases.search')}
                                    search={true}>
                                    <TableHeaderColumn
                                        columnTitle={true}
                                        dataField="id"
                                        hidden={true}
                                        isKey={true}
                                        export={true}>
                                        {t('common_phrases.id')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn columnTitle={true} dataField="name" width="300" dataSort={true}>
                                        {t('common_phrases.name')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataField="actions"
                                        width="90"
                                        dataFormat={this.tableActionsFormatter}
                                        export={false}>
                                        {t('common_phrases.actions')}
                                    </TableHeaderColumn>
                                </BootstrapTable>
                            </BootstrapTableErrorBoundary>
                        );
                })()}
            </div>
        );
    }

    onProceedCopy(seasonCalculation) {
        const { selectedCompany } = this.props;

        this.props.save(seasonCalculation, Entities.SEASON_CALCULATION, selectedCompany);
    }

    onProceedDelete(seasonCalculation) {
        const { selectedCompany } = this.props;

        this.props.deleteById(seasonCalculation.id, Entities.SEASON_CALCULATION, selectedCompany);
    }

    openConfirmCopyDialog(copyName, seasonCalculationCopy, name) {
        const { t } = this.props;
        seasonCalculationCopy.name = copyName;

        this.props.openModal({
            component: ConfirmDialog,
            componentProps: {
                event: seasonCalculationCopy,
                onProceedDialog: this.onProceedCopy,
                bodyText: t('calculation.confirm_duplicate_special'),
                proceedText: t('user_functionality.duplicate'),
                cancelText: t('common_phrases.no'),
                cancelButtonColor: ButtonColors.NOTIFY,
                proceedButtonColor: ButtonColors.SUCCESS,
            },
            title: name,
            noButtons: true,
        });
    }

    openConfirmDeleteDialog(seasonCalculation) {
        const { t } = this.props;
        if (this.table) this.table.reset();
        this.props.openModal({
            component: ConfirmDialog,
            componentProps: {
                event: seasonCalculation,
                onProceedDialog: this.onProceedDelete,
                bodyText: t('calculation.confirm_delete_special'),
                proceedText: t('user_functionality.delete'),
                cancelText: t('common_phrases.no'),
                cancelButtonColor: ButtonColors.NOTIFY,
                proceedButtonColor: ButtonColors.DANGER,
            },
            title: seasonCalculation.name,
            noButtons: true,
        });
    }

    openCannotDeleteDialog() {
        const { t } = this.props;

        this.props.openModal({
            component: ConfirmDialog,
            componentProps: {
                bodyText: t('calculation.error_special_related'),
                proceedText: t('common_phrases.ok'),
                proceedButtonColor: ButtonColors.NOTIFY,
                isNotification: true,
            },
            title: t('common_phrases.attention'),
            noButtons: true,
        });
    }

    tableActionsFormatter(cell, seasonCalculation) {
        const { selectedCompany, seasonCalculations, t } = this.props;

        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() => {
                        this.props.openModal({
                            component: SeasonCalculationEditModal,
                            componentProps: {
                                isCreate: false,
                                tripCompanies: this.state.tripCompanies.entities,
                                id: seasonCalculation.id,
                            },
                            title: seasonCalculation.name,
                            mandatoryFields: true,
                        });
                    }}>
                    <span title={t('user_functionality.edit')} className="glyphicon glyphicon-pencil text-info" />
                </button>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() => {
                        // get selected seasonCalculation from state and crop props for saving a seasonCalculation copy
                        const seasonCalculationCopy = Object.assign(
                            {},
                            seasonCalculations.items.find(entity => entity.id === seasonCalculation.id),
                        );
                        delete seasonCalculationCopy.id;
                        delete seasonCalculationCopy._links;
                        delete seasonCalculationCopy.buses;
                        // replace company object with URL to company
                        seasonCalculationCopy.company = `${TOMCAT_URL}api/${Entities.BUS_COMPANY.repository}/${selectedCompany}`;
                        // replace trip company objects in season surcharges with URLs to trip companies
                        seasonCalculationCopy.seasonSurcharges = seasonCalculationCopy.seasonSurcharges.map(
                            surcharge => ({
                                ...surcharge,
                                tripCompany: surcharge.tripCompany
                                    ? `${TOMCAT_URL}api/${Entities.TRIP_COMPANY.repository}/${surcharge.tripCompany.id}`
                                    : undefined,
                            }),
                        );

                        if (seasonCalculationCopy.zoneTimeIntervals)
                            Object.keys(seasonCalculationCopy.zoneTimeIntervals).forEach(day => {
                                if (seasonCalculationCopy.zoneTimeIntervals[day]) {
                                    // remove time interval first property if contained values are null
                                    if (seasonCalculationCopy.zoneTimeIntervals[day].first) {
                                        const first = seasonCalculationCopy.zoneTimeIntervals[day].first;
                                        if (!first.from || !first.to)
                                            seasonCalculationCopy.zoneTimeIntervals[day].first = null;
                                    }

                                    // remove time interval second property if contained values are null
                                    if (seasonCalculationCopy.zoneTimeIntervals[day].second) {
                                        const second = seasonCalculationCopy.zoneTimeIntervals[day].second;
                                        if (!second.from || !second.to)
                                            seasonCalculationCopy.zoneTimeIntervals[day].second = null;
                                    }

                                    // remove whole day if first and second opening hours are empty
                                    if (
                                        seasonCalculationCopy.zoneTimeIntervals[day].first == null &&
                                        seasonCalculationCopy.zoneTimeIntervals[day].second == null
                                    )
                                        seasonCalculationCopy.zoneTimeIntervals[day] = null;
                                }
                            });

                        asyncRequest(
                            `${TOMCAT_URL}api/${
                                Entities.SEASON_CALCULATION.repository
                            }/copyName?name=${encodeURIComponent(seasonCalculation.name)}&companyId=${selectedCompany}`,
                        ).then(response =>
                            this.openConfirmCopyDialog(
                                response.json.copyName,
                                seasonCalculationCopy,
                                seasonCalculation.name,
                            ),
                        );
                    }}>
                    <span title={t('user_functionality.duplicate')} className="fa fa-files-o text-warning" />
                </button>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() =>
                        asyncRequest(
                            `${TOMCAT_URL}api/${Entities.SEASON_CALCULATION.repository}/${seasonCalculation.id}/deletable`,
                        )
                            .then(response => this.openConfirmDeleteDialog(seasonCalculation))
                            .catch(error => this.openCannotDeleteDialog())
                    }>
                    <span title={t('user_functionality.delete')} className="glyphicon glyphicon-trash text-danger" />
                </button>
            </div>
        );
    }
}

SeasonCalculationAdministration.propTypes = {
    selectedCompany: PropTypes.number.isRequired,
    seasonCalculations: PropTypes.shape({
        items: PropTypes.array.isRequired,
        isFetching: PropTypes.bool.isRequired,
    }).isRequired,
};

export default withTranslation()(composeModalActions(SeasonCalculationAdministration));
